<template>
    <modal :title="$t('syslog.log_trig_setting')" :visible.sync="isShowDialog" width="600px">
        <div class="contentTree" v-loading="isLogLoading">
            <el-form :model="dioForm" inline>
                <el-form-item v-if="$store.state.type === 3 || $store.state.type === 2" :label="$t('public.table_scope')"
                    prop="sceneId">
                    <el-select style="width: 250px" v-model="dioForm.sceneId" @change="changeCurtmerFn">
                        <el-option v-for="item in rangeArray" :key="item.value" :label="$t(item.label)" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <!-- :default-expanded-keys="defaultExpandedKeys" -->
            <el-tree :props="props" show-checkbox :data="treeDataArray" :default-checked-keys="defaultKeys"
                node-key="functionCode" :render-content="renderContent" @check-change="handleCheckChange" ref="tree">
            </el-tree>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_apply') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { sysLogTree, sysLogSet } from '@/api/modules/operateLog.js';
export default {
    props: ['isSet', 'treeData', 'isLogLoading', 'rangeArray'],
    watch: {
        treeData(newVal) {
            // let Obj = this.TODODEEPTREE(newVal, {
            //     level1: [],
            //     level2: [],
            //     level3: [],
            // }, 'function_code', 'function_code');
            const sceneId = this.$store.getters.userInfo.scope.sceneId;

            const item = this.rangeArray.find(item => item.id === sceneId.toString());
            if (!item) {
                this.dioForm.sceneId = '';
            } else {
                this.dioForm.sceneId = sceneId + '';
            }
            this.defaultKeys = [];
            let newArray = [];
            this.defaultExpandedKeys = this.defaultKeys = this.TODODEEPTREE([...newVal], newArray);
            this.treeDataArray = [...newVal];
        },

    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isSet
            },
            set: function (val) {
                this.$emit('update:isSet', val);//可以优化成model  或者minx
            }
        },
    },
    data() {
        return {
            data: [],
            props: {
                label: 'label',
                children: 'item'
            },
            treeDataArray: [],
            defaultKeys: [],
            defaultExpandedKeys: [],
            dioForm: {
                sceneId: String(this.$store.getters.userInfo.scope.sceneId)
            }
        }
    },
    methods: {

        /** 下面的递归调用取消 */
        TODODEEPTREE(array = [], newArray) {
            array.forEach(option => {
                if (option.level === 3 && option.check === 2) {
                    if (newArray.indexOf(option.functionCode) === -1) {
                        newArray.push(option.functionCode)
                    }
                } else {
                    if (option.item && option.item.length > 0) {
                        this.TODODEEPTREE(option.item, newArray)
                    }
                }
            })
            return newArray
        },
        TODODEEPTREES(array = [], newArray) {
            array.forEach(option => {
                if (option.level === 3) {
                    if (newArray.indexOf(option.functionCode) === -1) {
                        newArray.push(option.functionCode)
                    }
                } else {
                    if (option.item && option.item.length > 0) {
                        this.TODODEEPTREE(option.item, newArray)
                    }
                }
            })
            return newArray
        },
        changeCurtmerFn(scopeId) {
            sysLogTree({ scopeId, local: this.$i18n.locale }).then(({ result }) => {
                this.defaultKeys = []
                let newArray = []
                this.defaultExpandedKeys = this.defaultKeys = this.TODODEEPTREE([...result.item], newArray);
                this.treeDataArray = [...result.item]
            })
        },
        handleSave() {
            let treeChooze = this.$refs['tree'].getCheckedNodes();
            let array = [];
            let checkArray = this.TODODEEPTREES(treeChooze, array);

            let Query = {
                scopeId: this.dioForm.sceneId,
                funcCodeList: checkArray
            }
            sysLogSet(Query).then(({ result }) => {
                if (result === 0) {
                    this.$message.error(this.$t("syslog.code_0"))
                } else if (result === 1) {
                    this.$message.success(this.$t("syslog.code_1"));
                    this.isShowDialog = false
                } else {
                    this.$message.error(this.$t("syslog.code_other"))
                }
            })
        },
        renderContent() {
            let createElement = arguments[0];
            let node = arguments[1].node;
            let data = arguments[1].data;
            // 优先使用后端返回的本地化名称（与系统左侧菜单 generateTitle 逻辑一致）
            let locale = this.$i18n.locale || '';
            let isZh = locale.indexOf('zh') === 0;
            let zhName = data.nameZh;
            let enName = data.nameEn;
            if (isZh && zhName) return createElement('span', zhName);
            if (!isZh && enName) return createElement('span', enName);
            // 兜底：level 3 用 func. 前缀，其他用 route. 前缀
            return node.level === 3
                ? createElement('span', this.$t('func.' + node.label))
                : createElement('span', this.$t('route.' + node.label))
        },
        handleCheckChange() { }
    }
}
</script>

<style lang="scss" scoped>
.contentTree {
    height: 500px;
    overflow: auto;
}
</style>
